import React, { useState } from 'react';
import EmployeeLayout from './EmployeeLayout';

const UpdateStatus = () => {
  const [formData, setFormData] = useState({
    leadId: '',
    status: '',
    notes: '',
    date: new Date().toISOString().split('T')[0],
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Status updated successfully!');
    setFormData({ leadId: '', status: '', notes: '', date: new Date().toISOString().split('T')[0] });
  };

  const assignedLeads = [
    { id: 1, name: 'Rahul Sharma' },
    { id: 2, name: 'Priya Patel' },
    { id: 3, name: 'Amit Kumar' },
  ];

  return (
    <EmployeeLayout>
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white">Update Lead Status</h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">Log updates following site visits or client calls</p>
      </div>

      <div className="max-w-2xl">
        <div className="bg-white dark:bg-slate-900/50 rounded-2xl shadow-sm dark:shadow-xl border border-slate-200 dark:border-slate-800 p-6 sm:p-8 transition-colors">
          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Select Lead */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">
                Select Lead *
              </label>
              <select
                name="leadId"
                value={formData.leadId}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
                required
              >
                <option value="">Select a lead</option>
                {assignedLeads.map((lead) => (
                  <option key={lead.id} value={lead.id}>
                    {lead.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Status */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">
                Status *
              </label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
                required
              >
                <option value="">Select status</option>
                <option value="New">New</option>
                <option value="In Progress">In Progress</option>
                <option value="Site Visit Done">Site Visit Done</option>
                <option value="Quotation Sent">Quotation Sent</option>
                <option value="Converted">Converted</option>
                <option value="Lost">Lost</option>
              </select>
            </div>

            {/* Date */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">
                Date
              </label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
              />
            </div>

            {/* Notes */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">
                Notes
              </label>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                rows="4"
                placeholder="Add meeting notes, customer preferences, or site constraints..."
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium"
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full px-6 py-3 bg-[#10B981] hover:bg-emerald-600 text-white font-bold rounded-xl shadow-lg shadow-emerald-500/20 transition-all text-sm"
            >
              Update Status
            </button>
          </form>
        </div>
      </div>
    </EmployeeLayout>
  );
};

export default UpdateStatus;